import React, { useState } from "react";
import { Modal as ModalComponent } from "../common/Modal.jsx";
import { Portal } from "../common/Portal.jsx";

const CompleteCellContentModal = (props) => {
  const [show, setShow] = useState(false);
  const [completeFieldContent, setCompleteFieldContent] = useState("");

  const handleClose = () => {
    setShow(false);
  } 
  const handleShow = () => {
    setShow(true);
    setCompleteFieldContent(props.cellContent);
  } 
  return (
    <>
      <a style={{whiteSpace: "nowrap"}} onClick={handleShow}>
        {props.cellLabel || props.cellContent}
      </a>
      {show && (
        <Portal
          id={`datagrid-long-text-modal-${props.cellIdentifier}`} 
          title={props.title}
          onClose={handleClose}
          hideButtons={true}
          size="lg"
          component={ModalComponent}
        >
          {props.asJson ? <pre>{completeFieldContent}</pre> : <span>{completeFieldContent}</span>}
        </Portal>
      )}
    </>
  );
}

export default CompleteCellContentModal;
